<a data-toggle="modal"
   data-target="#aside">
  <cc-top-bar-item [showInMobile]="true" [title]="title | translate" >
    <i class="material-icons">&#xe5d2;</i>
  </cc-top-bar-item>
</a>
<cc-top-bar-item [showAlways]="true">
  <div class="title text-ellipsis sm-down-text-ellipsis"
       title="{{title | translate}}"
       [class.advanced-title]="hideSubMenu" [title]="title | translate">
    <span>{{title | translate}}</span>
    <span *ngIf="titleBeta"
          class="beta-sign">Beta</span>
  </div>
</cc-top-bar-item>
<div class="ng-transclude show-always"
     [class.open]="showSubMenu">
  <ng-content></ng-content>
</div>
<!--<cc-top-bar-item class="mobile-hidden"-->
<!--                 [showInMobile]="true"-->
<!--                 [hidden]="hideSubMenu"-->
<!--                 [ngClass]="{'primary-hover active' : showSubMenu}"-->
<!--                 (click)="showSubMenu = !showSubMenu;">-->
<!--  <i class="material-icons text-md ">expand_more</i>-->
<!--</cc-top-bar-item>-->
